import { render, staticRenderFns } from "./TopCanvasserNavigation.vue?vue&type=template&id=1b8ce2e2&"
import script from "./TopCanvasserNavigation.vue?vue&type=script&lang=js&"
export * from "./TopCanvasserNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports